import { createSlice } from '@reduxjs/toolkit';




import { MANAGE_EMPLOYEE } from '../../actions/ManageEmployee/ManageActionType';


const initialState = {
  manageEmployeeCycles: {
    isLoading: false,
    // data: {
        
    // Must be an object (API envelope). [] made valuesData.assessmentCyclList undefined and emptied the cycle dropdown.
    assessmentCycles: {},
    dropDown: [],

    data:null,
    errors: '',
    message: '',
    /** Admin reset assessment (Manage Employee — permission A); soft UX — no full-page reload */
    adminReset: {
      loading: false,
      error: '',
      message: ''
    }
  }
};

export const manageEmployeeSlice = createSlice({
  name: MANAGE_EMPLOYEE,
  initialState,
  reducers: {
    getManageEmployeesAction: (state) => {
      state.manageEmployeeCycles.isLoading = true;
      state.manageEmployeeCycles.errors = '';
    },
    getManageEmployeesSuccessAction: (state, action) => {

      if (action.payload) {
        state.manageEmployeeCycles.assessmentCycles = action.payload;
      
      }
      state.manageEmployeeCycles.isLoading = false;
    },
    getManageEmployeesFailureAction: (state, action) => {
      // state.user.isLoading = false;
      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = action.payload;
    },
    setManageEmployeeAction: (state) => {
      state.manageEmployeeCycles.isLoading = true;
      state.manageEmployeeCycles.errors = '';
    },
    updateManageEmployeeAction: (state) => {
      state.manageEmployeeCycles.isLoading = true;
      state.manageEmployeeCycles.errors = '';
    },
    setManageEmployeesSuccessAction: (state, action) => {
      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = '';
      const payload = action.payload || {};
      const statusCode = payload.statusCode ?? payload.StatusCode;
      const data = payload.data ?? payload.Data;
      const isSuccess =
        statusCode === 201 ||
        data === 1 ||
        data === '' ||
        data === null;
      if (isSuccess) {
        state.manageEmployeeCycles.message = 'Saved Successfully!';
      } else {
        const failedEmails =
          typeof data === 'string' && data.trim() ? data : '';
        state.manageEmployeeCycles.errors = failedEmails
          ? `Could not add: ${failedEmails}`
          : 'Cannot save. Employee already exists!';
      }
    },
    setManageEmployeesFailureAction: (state, action) => {
      state.manageEmployeeCycles.isLoading = false;
      const errPayload = action.payload;
      state.manageEmployeeCycles.errors =
        typeof errPayload === 'string' && errPayload
          ? errPayload
          : 'Please Enter Valid Email Id';
    },
    resetManageEmployeeeAction: (state) => {
      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = '';
      state.manageEmployeeCycles.message = '';
    },
    setDropDownAction: (state,) => {
      state.isLoading = true;
      state.manageEmployeeCycles.errors = '';
    },
    
    setDropDownSuccessAction: (state, action) => {

      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = '';
      if (action.payload?.data === 1) {
        state.manageEmployeeCycles.message = 'Mapped Successfully!';
      } else {
        state.manageEmployeeCycles.errors = 'Cannot save. Employee already exists!';
      }
    },
    setDropDownFailureAction: (state, action) => {
      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = action.payload;
    },   
    setUpdateStatusAction: (state,) => {
      state.isLoading = true;
      state.manageEmployeeCycles.errors = '';
    },

    setUpdateStatusSuccessAction: (state, action) => {

      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = '';
      if (action.payload?.data === 1) {
        state.manageEmployeeCycles.message = 'Update Status Successfully!';
      } else {
        state.manageEmployeeCycles.errors = 'Cannot save. Employee already exists!';
      }
    },
    setUpdateStatusFailureAction: (state, action) => {
      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = action.payload;
    },
    setUpdateManagerAction: (state,) => {
      state.isLoading = true;
      state.manageEmployeeCycles.errors = '';
    },

    setUpdateManagerSuccessAction: (state, action) => {

      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = '';
      if (action.payload?.data === 1) {
        state.manageEmployeeCycles.message = 'Update Status Successfully!';
      } else {
        state.manageEmployeeCycles.errors = 'Cannot save. Employee already exists!';
      }
    },
    setUpdateManagerFailureAction: (state, action) => {
      state.manageEmployeeCycles.isLoading = false;
      state.manageEmployeeCycles.errors = action.payload;
    },
    adminResetAssessmentAction: (state) => {
      state.manageEmployeeCycles.adminReset.loading = true;
      state.manageEmployeeCycles.adminReset.error = '';
      state.manageEmployeeCycles.adminReset.message = '';
    },
    adminResetAssessmentSuccessAction: (state, action) => {
      state.manageEmployeeCycles.adminReset.loading = false;
      state.manageEmployeeCycles.adminReset.message =
        action.payload?.message || 'Assessment reset completed successfully.';
      state.manageEmployeeCycles.adminReset.error = '';
    },
    adminResetAssessmentFailureAction: (state, action) => {
      state.manageEmployeeCycles.adminReset.loading = false;
      state.manageEmployeeCycles.adminReset.error =
        typeof action.payload === 'string' ? action.payload : 'Assessment reset failed.';
      state.manageEmployeeCycles.adminReset.message = '';
    },
    clearAdminResetAssessmentFeedbackAction: (state) => {
      state.manageEmployeeCycles.adminReset.error = '';
      state.manageEmployeeCycles.adminReset.message = '';
    }
  }
  
});

export const {
  getManageEmployeesAction,
    getManageEmployeesSuccessAction,
    getManageEmployeesFailureAction,
    setManageEmployeeAction,
    updateManageEmployeeAction,
    setManageEmployeesSuccessAction,
    setManageEmployeesFailureAction,
    resetManageEmployeeeAction,
    setDropDownAction,
    setDropDownSuccessAction,
    setDropDownFailureAction,
    setUpdateStatusAction,
    setUpdateStatusSuccessAction,
    setUpdateStatusFailureAction,
    setUpdateManagerSuccessAction,
    setUpdateManagerFailureAction,
    setUpdateManagerAction,
    adminResetAssessmentAction,
    adminResetAssessmentSuccessAction,
    adminResetAssessmentFailureAction,
    clearAdminResetAssessmentFeedbackAction

} = manageEmployeeSlice.actions;

export default manageEmployeeSlice.reducer;
     